import { cssColor } from "@stenajs-webui/theme";

export const TAG_BACKGROUND_COLOR_INFO = cssColor("--lhds-color-blue-100");
export const TAG_BACKGROUND_COLOR_PASSIVE = cssColor("--silver-lighter");
export const TAG_BACKGROUND_COLOR_WHITE = "#fff";
export const TAG_BACKGROUND_COLOR_SUCCESS = cssColor("--lhds-color-green-100");
export const TAG_BACKGROUND_COLOR_SUCCESS_STRONG = cssColor(
  "--lhds-color-green-200",
);
export const TAG_BACKGROUND_COLOR_WARNING = cssColor("--lhds-color-orange-100");
export const TAG_BACKGROUND_COLOR_ERROR = cssColor("--lhds-color-red-100");
